export const resources = {
  en: {
    translation: {
      TITLE: "DIGITAL METRONOME",
      SONGS_THAT_USE_THIS_BPM: "Songs that use this BPM",
    },
  },
};
